import { EntityState, EntityStore, EntityUIStore, MultiActiveState, StoreConfig } from "@datorama/akita";
import { Injectable } from "@angular/core";
import { TransactionExtended, TransactionExtendedItem } from "./transaction.extended.model";

export interface TransactionExtendedState extends EntityState<TransactionExtended, number>, MultiActiveState{
    itemDetails: { [key: string]: TransactionExtendedItem[] };
}

export interface TransactionExtendedUI{
    TransactionRef: number;
    isLoading: boolean;
}

export interface TransactionExtendedUIState extends EntityState<TransactionExtendedUI>{
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'transactions-extended', idKey: 'TransactionRef' })
export class TransactionExtendedStore extends EntityStore<TransactionExtendedState>{
    ui: EntityUIStore<TransactionExtendedUIState>;

    constructor(){
        super({
            active: [ ],
            itemDetails: {},
            loading: false
        });
        this.createUIStore();
    }

    setItemDetails(id: number, items: TransactionExtendedItem[]): void{
        this.update((state: TransactionExtendedState) => {
            return {
                itemDetails: {
                    ...state.itemDetails,
                    ...{ [id]: items }
                }
            }
        })
    }

    setUILoading(id: number, value: boolean): void{
        this.ui.upsert(id, { isLoading: value });
    }

    restoreDefaults(): void{
        this.update(() => {
            return {
                active: [],
                entities: [],
                ids: [],
                loading: false
            }
        });
    }

}